module.exports = __webpack_public_path__ + "static/media/DesktopMainBanner.b4cebf10.png";